// --- Document ---

export const DEFAULT_DOCUMENT_BACKGROUND_COLOR = '#ffffffff';
export const DEFAULT_FONT_COLOR = '#212121FF';

// --- Blocks ---

export const DEFAULT_BLOCK_BACKGROUND_COLOR = '#ffffff00';
export const DEFAULT_BLOCK_BORDER_COLOR = '#ffffffff';
export const DEFAULT_SHAPE_BACKGROUND_COLOR = '#d9d9d9ff';

// --- Sections ---

export const DEFAULT_SECTION_TITLE_BORDER_COLOR = '#0000003B';

// --- Tables ---

export const DEFAULT_TABLE_BACKGROUND_COLOR = '#ffffff';
export const DEFAULT_TABLE_BODY_ROW_BACKGROUND_COLOR = '#ffffff';
export const DEFAULT_TABLE_HEADER_ROW_BACKGROUND_COLOR = '#757575';
export const DEFAULT_TABLE_FOOTER_ROW_BACKGROUND_COLOR = '#EFEFEF';
export const DEFAULT_TABLE_SUBTOTAL_ROW_BACKGROUND_COLOR = '#FAFAFA';
export const DEFAULT_TABLE_TOTAL_ROW_BACKGROUND_COLOR = '#FAFAFA';

export const DEFAULT_TABLE_HEADER_ROW_FONT_COLOR = '#ffffff';
export const DEFAULT_TABLE_ROW_FONT_COLOR = '#212121';
